import React, { Dispatch, FC, ReactNode, createContext, useContext, useReducer } from "react";
import { OrderLine } from "../lib/models/OrderLine";
import { AuthToken } from "../lib/auth/auth";

const AuthState = {
  NOT_LOGGED_IN: "NOT_LOGGED_IN",
  LOGGED_IN: "LOGGED_IN",
  LOGGING_IN: "LOGGING_IN",
} as const;

type AuthState = keyof typeof AuthState;

type AppState = {
  isAuthenticated: boolean;
  seller?: string;
  orderLines: OrderLine[];
  projectName?: string;
  projectNumber?: string;
  tokens?: AuthToken;
  authState?: AuthState;
};

const initialState: AppState = {
  isAuthenticated: false,
  orderLines: [],
  seller: "",
  projectName: "",
  projectNumber: "",
  authState: AuthState.NOT_LOGGED_IN,
};

export type AppStateDispatch = Dispatch<Actions>;
type Actions =
  | ["SET_ORDERS", { orderLines: OrderLine[] }]
  | ["SET_TOKENS", { tokens?: AuthToken }]
  | ["SET_AUTH_STATE", { state?: AuthState }]
  | ["SET_SELLER", { seller: string }]
  | ["SET_PROJECT_META", { projectName: string; projectNumber: string }];

const AppContext = createContext<undefined | { state: AppState; dispatch: Dispatch<Actions> }>(undefined);

const appStateReducer = (state: AppState, action: Actions) => {
  const [type, payload] = action;
  const newState = { ...state };
  console.log(type, payload);
  switch (type) {
    case "SET_ORDERS": {
      newState.orderLines = payload.orderLines;
      return newState;
    }
    case "SET_AUTH_STATE": {
      newState.authState = payload.state;
      return newState;
    }
    case "SET_TOKENS": {
      newState.tokens = payload.tokens;
      return newState;
    }
    case "SET_PROJECT_META": {
      newState.projectName = payload.projectName;
      newState.projectNumber = payload.projectNumber;
      return newState;
    }
    case "SET_SELLER": {
      newState.seller = payload.seller;
      return newState;
    }
  }
};

export const AppContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(appStateReducer, initialState);
  return (
    <AppContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppState = () => {
  const state = useContext(AppContext);
  if (!state) throw new Error("Missing App context provider");
  return state;
};
